// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_zAq","cls2":"CoScientistLandingPage-cls2_7nE CoScientistLandingPage-cls1_zAq"};